import styled from 'styled-components';
import {Link as LinkR} from 'react-router-dom';

export const ResumeContainer = styled.div`
    color: white;
    background: ${({lightBg}) => (lightBg ? '#f9f9f9' : '#010606')};
    padding: 100px 0; 

    @media screen and (max-width: 768px) {
        padding: 100px 0;
    }
`;

export const ResumeWrapper = styled.div`
    display: grid;
    z-index: 1;
    height: 700px;
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    justify-content: center;
`;

export const ResumeRow = styled.div`
    display: grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items: center;
    grid-template-areas: ${({imgStart}) => (imgStart ? `'col2 col1'` : `'col1 col2'`)};

    @media screen and (max-width: 768px) {
        grid-template-areas: ${({imgStart}) => (imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`)};
    }
`;

export const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col1;
`;

export const Column2 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col2;
`;

export const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 60px;
`;

export const TopLine = styled.p`
    color: #1A61FA;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 16px;
`;

export const Heading = styled.h1`
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 1.1;
    font-weight: 600;
    color: ${({lightText}) => (lightText ? '#D0D3F9' : '#010606')};

    @media screen and (max-width: 768px) {
        font-size: 1rem;
    }
`;

export const Subtitle = styled.p`
    max-width: 440px;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 24px;
    text-align: left;
    white-space: pre-line;

    color: ${({darkText}) => (darkText ? '#010606' : '#f7f8fa')};
`;


export const BtnWrap = styled.div`
    display: flex;
    justify-content: flex-start;
`;

export const BtnWrap2 = styled(LinkR)`
    color: #fff;
    justify-self: start;
    cursor: pointer;
    text-decoration: none;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    font-weight: bold;
`;

export const ImgWrap = styled.div`
    max-width: 555px;
    height: 100%;
`;

export const Img = styled.img`
    width: 125%;
    margin: 0 0 10px 0;
    padding-right: 0;
    border-radius: 80px 100px;

    @media screen and (max-width: 768px) {
        width: auto;
    }
`;

